import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Logo } from '../common/Logo';

export function LoginPage() {
  const { isAuthenticated, isLoading, signIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-primary flex items-center justify-center">
        <div className="animate-spin-slow w-8 h-8 border-2 border-coral border-t-transparent rounded-full" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-primary flex items-center justify-center p-6">
      {/* Login Card */}
      <div className="w-full max-w-[400px] bg-white rounded-card p-8 shadow-card">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <Logo size="lg" variant="light" />
        </div>

        {/* Heading */}
        <h1 className="text-heading-2 font-semibold text-dark-text text-center mb-2">
          Welcome back
        </h1>
        <p className="text-body text-gray-medium text-center mb-8">
          Sign in to continue
        </p>

        {/* Sign In Button */}
        <button
          onClick={signIn}
          className="btn-primary w-full text-body-lg"
        >
          Sign in with Microsoft
        </button>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-gray-light">
          <p className="text-caption text-gray-medium text-center">
            Website Compliance Scanner by{' '}
            <span className="text-coral font-medium">Space01</span>
          </p>
        </div>
      </div>
    </div>
  );
}
